const constants =  {
    delivery: {
        REPARATIE: 1,
        UITDIENST: 2,
        INDIENST: 3,
        EOL_SWAP: 4,
        EXTRA_PRODUCTEN: 5,
        BULK_LEVERING: 6,
        BACKORDER: 7,
        MUTATIE: 8
    },
    client: {
        REUZADO: 1,
        RESELLER: 2,
        EINDKLANT: 3,
        EINDGEBRUIKER: 4,
    },
    status: {
        INGEKLAARD: 1,
        UITGEKLAARD: 2,
        IN_GEBRUIK: 3,
        REPARATIE: 4,
        OP_AFROEP: 5,
        EOL: 6,
        IN_BEHANDELING: 7,
        REPARATIE_AANGEVRAAGD: 8,
        VERMIST: 13,
        REPARATIE_ONTVANGEN: 14,
        REPARATIE_IN_BEHANDELING: 15,
        REPARATIE_AFGEROND: 16,
        WACHTEN_OP_ONDERDELEN: 17,
        WACHTEN_OP_GOEDKEURING_OFFERTE: 18,
        VOORRAAD_KLANTLOCATIE: 19
    },
    carrier: {
        REUZADO: 1,
        POSTNL: 2,
        OVERIG: 3
    },
    quatation_status: {
        ACCEPTEREN: 'Accept',
        WEIGEREN: 'Decline'
    },
    getClientTypeWithId(id) {
        if (typeof id === 'string') id = parseInt(id);
        switch (id) {
            case 1:
                return 'Reuzado';
            case 2:
                return 'Reseller';
            case 3:
                return 'Eindklant';
            case 4:
                return 'Eindgebruiker';
            default:
                return 'Onbekend';
        }
    },
}
export default {
    install: app => {
        app.config.globalProperties.$constants = constants;
    }
}
